import type { FC, PropsWithChildren } from "react";
import { styled } from "@mui/material/styles";

const EnvBadge: FC<PropsWithChildren> = styled("aside")(`
  position: absolute;
  min-width: 200px;
  padding: 0 5px;
  inset-block-start: 0;
  inset-inline-start: calc(50% - 100px);
  border-radius: 0 0 10px 10px;
  color: var(--app-nav-bg-color);
  background: var(--brand-sunset-300);
  font-size: 14px;
  font-family: monospace;
  font-weight: bold;
  text-align: center;
  z-index: 1;
  opacity: 0.5;
  pointer-events: none;
`);

export default EnvBadge;
